<template>
  <div class="logged-out-view">
    <section class="top-section first-section">
      <div class="top-block">
        <h2 class="page-title">JOIN MAXQUEST</h2>
        <h3 class="page-subtitle">
          WIN
          <span class="gold--text">REAL PRIZES</span>
          <br />
          ON GAMES OF SKILL
        </h3>
        <p class="page-lead">
          Guaranteed winner in
          <br />
          <span class="gold--text">EVERY ROUND!</span>
        </p>
        <YellowButton class="play-button" @click="openSignUpDialog">Play now</YellowButton>
      </div>
      <div class="art-devices">
        <img v-if="isDesktop" src="/images/hp-lo/art-devices-new-desktop.webp?v=5" alt="art-device-image" />
        <img v-else src="/images/hp-lo/art-devices-new-mobile.webp?v=5" alt="art-device-image" />

        <!--
        <div class="svg-wrapper" @click="showVideo">
          <img src="/images/icons/play-arrow.png?v=2" width="21" height="26" alt="play promotional video" />
        </div>
        -->
      </div>
    </section>

    <section class="hero-bg">
      <div class="top-block">
        <h2 class="page-title">Original & EXCLUSIVE Games</h2>
        <p class="page-lead">
          From Max Blast Champs, the 1
          <sup>st</sup>
          of its kind crash game to MultiPlinko and Sector X, MaxQuest sets the standard for game design, offering a
          truly original and exclusive gaming experience.
        </p>
      </div>
      <div class="art-characters" />
    </section>

    <section
      v-if="$vuetify.breakpoint.width < 900"
      class="carousel-container"
      :class="{ 'carousel-container--fade': showSwiperFade }"
    >
      <swiper-container ref="swiperElement" class="banners-carousel" v-bind="swiperOptions">
        <swiper-slide v-for="(banner, index) in banners" :key="index" class="banner-slide" @click="openSignUpDialog">
          <v-img :src="banner.src" alt="banner" class="banner-image">
            <h4 class="banner-title" v-html="banner.title" />
            <p class="banner-lead">
              {{ banner.lead }}
            </p>
          </v-img>
        </swiper-slide>
      </swiper-container>
    </section>
    <section v-else class="carousel-container">
      <div v-for="(banner, index) in banners" :key="index" class="banner-slide" @click="openSignUpDialog">
        <v-img :src="banner.src" alt="banner" class="banner-image">
          <h4 class="banner-title" v-html="banner.title" />
          <p class="banner-lead">
            {{ banner.lead }}
          </p>
        </v-img>
      </div>
    </section>

    <section class="game-section">
      <img v-if="!isMobileOrTablet" src="/images/hp-lo/pvp-bg-desktop.webp?v=1" alt="PVP background" class="pvp-bg" />

      <div class="top-block position-relative">
        <h2 class="page-title">{{ gameListTitle }}</h2>
        <p class="page-lead" v-html="gameListDescription"></p>
      </div>

      <!--      <div class="game-tabs">-->
      <!--        <div :class="{ 'game-tab&#45;&#45;active': isPvpTab }" class="game-tab" @click="activeTab = 'pvp'">-->
      <!--          <IconPvp />-->
      <!--          <span>Player vs Player</span>-->
      <!--        </div>-->
      <!--        <div :class="{ 'game-tab&#45;&#45;active': !isPvpTab }" class="game-tab" @click="activeTab = 'fastplay'">-->
      <!--          <IconFastplay />-->
      <!--          <span>FastPlay</span>-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="game-list">
        <div v-for="(sourceUrl, i) in gameList" :key="`${activeTab}-${i}`" class="game-card">
          <img :src="sourceUrl" alt="MaxQuest game card" />
        </div>

        <YellowButton class="all-games-button" @click="openSignUpDialog">See all games</YellowButton>
      </div>
    </section>

    <section class="deposit-options">
      <div class="top-block">
        <h2 class="page-title">Purchase Options</h2>
        <p class="page-lead">
          Purchase coins in all major cryptocurrencies, on all of the popular chains - new coins and purchase methods
          are being added each week.
        </p>
      </div>
      <div class="art-crypto" />
      <div class="bottom-block">
        <div class="kado-text-wrapper">
          <div class="kado-text" />
        </div>
        <div class="art-cards" />
      </div>
    </section>
  </div>
</template>

<script>
  import YellowButton from '@/components/base/YellowButton.vue';
  // import IconPvp from '@/assets/images/svg/icon-pvp.svg';
  // import IconFastplay from '@/assets/images/svg/icon-fastplay.svg';
  import breakpoints from '@/mixins/breakpoints';

  const PVP_LIST = [
    '/images/cards/hp/pvp-mp.webp?v=1',
    '/images/cards/hp/pvp-mm.webp?v=1',
    '/images/cards/hp/pvp-mbc.webp?v=1',
    '/images/cards/hp/pvp-sx.webp?v=1',
    '/images/cards/hp/pvp-ds.webp?v=1',
    '/images/cards/hp/pvp-ma.webp?v=1',
  ];
  const FASTPLAY_LIST = [
    //'/images/cards/hp/tmb.webp?v=1',
    '/images/cards/hp/sx.webp?v=1',
    //'/images/cards/hp/fm.webp?v=1',
    '/images/cards/hp/ds.webp?v=1',
    '/images/cards/hp/ma.webp?v=1',
    //'/images/cards/hp/op.webp?v=1',
  ];

  export default {
    name: 'LoggedOutView',

    components: {
      YellowButton,
      // IconPvp,
      // IconFastplay,
    },

    mixins: [breakpoints],

    data: () => ({
      activeTab: 'pvp',
      showSwiperFade: false,
    }),

    computed: {
      isMobileOrTablet() {
        return this.$vuetify.breakpoint.width <= 550;
      },

      banners() {
        const suffix = this.isMobileOrTablet ? 'mobile' : 'desktop';
        return [
          {
            src: `/images/hp-lo/banner-caf-${suffix}.webp?v=4`,
            alt: 'Challenge friends',
            title: 'Challenge<br /> friends',
            lead: 'This social feature allows players to add friends, create private game rooms, and compete head-to-head.',
          },
          {
            src: `/images/hp-lo/banner-raf-${suffix}.webp?v=4`,
            alt: 'Refer a friend',
            title: 'Refer a<br />friend',
            lead: 'Bring your friends to the MaxQuest platform and earn extra rewards. The more friends you refer, the more benefits you can unlock!',
          },
        ];
      },

      swiperOptions() {
        return {
          'slides-per-view': 1.15,
          'space-between': 16,
          loop: false,
          // speed: 600,
          // 'autoplay-delay': 3000,
          // 'autoplay-pause-on-mouse-enter': true,
        };
      },

      isPvpTab() {
        return this.activeTab === 'pvp';
      },

      gameList() {
        const res = this.isPvpTab ? PVP_LIST : FASTPLAY_LIST;

        if (this.$vuetify.breakpoint.width <= 743) return res.slice(0, 3);
        return res;
      },

      gameListTitle() {
        return this.isPvpTab ? 'PLAYER VS PLAYER' : 'FISH TABLE GAMES';
      },

      gameListDescription() {
        return this.isPvpTab
          ? 'Cutting-edge PvP games in which players compete for the entire prize pot'
          : "MaxQuest's dynamic Fish style shooter games - Sector X, DragonStone and Mission Amazon.";
      },
    },

    mounted() {
      this.$refs.swiperElement?.swiper?.on('slideChange', this.onSlideChange);
    },

    beforeDestroy() {
      this.$refs.swiperElement?.swiper?.off('slideChange', this.onSlideChange);
    },

    methods: {
      openSignUpDialog() {
        this.$store.dispatch('changeSignupDialogState', true);
      },

      showVideo() {
        this.$store.commit('SET_SHOW_VIDEO_POPUP', true);
      },

      onSlideChange() {
        // this.$refs.swiperElement?.swiper?.on('slideChange', ({ activeIndex }) => {
        //   this.showSwiperFade = activeIndex !== this.banners.length - 1;
        // });
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import 'src/scss/mixins';

  @keyframes play-pulse-anim {
    to {
      box-shadow: 0 0 0 20px rgba(53, 15, 83, 0.2);
    }
  }

  @media (min-width: 1000px) {
    .art-devices {
      align-self: flex-end;
    }
  }

  .logged-out-view {
    @include basic-spacings;
    margin-inline: auto;
    padding-top: 24px;
    padding-bottom: 24px;
    display: flex;
    flex-direction: column;
    container: loggedOutView / inline-size;
    max-width: 1448px;

    @media screen and (min-width: 1280px) {
      padding-inline: 48px;
    }

    @media screen and (min-width: 1600px) {
      padding-inline: 0;
    }

    section {
      max-width: 1468px;
      width: 100%;
      margin-block: auto;
    }

    .carousel-container {
      &--fade:after {
        content: '';
        background: linear-gradient(270deg, #350f53 0%, rgba(53, 15, 83, 0) 100%);
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 15%;
        z-index: 1;
        pointer-events: none;
      }

      @media screen and (min-width: 900px) {
        display: flex;
        gap: 16px;
      }
    }

    .banner-slide {
      cursor: pointer;
      aspect-ratio: 612/1120;

      &:hover {
        filter: brightness(105%);
      }

      @media screen and (min-width: 551px) {
        aspect-ratio: 1074/600;
      }

      @media screen and (min-width: 900px) {
        flex-basis: 100%;
      }
    }

    .banner-image {
      container: bannerImage / inline-size;
      width: 100%;
      height: 100%;

      &::v-deep {
        .v-responsive__content {
          align-self: flex-end;
          padding: 40px 16px;
        }

        .banner-title {
          color: var(--Colors-White, #fff);
          font-family: 'Big Shoulders Display', sans-serif;
          font-weight: 800;
          line-height: 110%;
          text-transform: uppercase;
        }

        .banner-lead {
          color: var(--Colors-White, #fff);
          font-family: 'Barlow', sans-serif;
          font-weight: 600;
          line-height: 150%;
          margin: 0;
        }
      }
    }

    @container loggedOutView (min-width: 220px) {
      section {
        position: relative;
        overflow: hidden;
        border-radius: 20px;
        //background: radial-gradient(73.26% 39.87% at 50% 56.43%, #350f53 0%, #1b0831 100%);
        margin-bottom: 24px;

        &.hero-bg {
          position: relative;
          width: 100%;
          background: url(/images/hp-lo/hero-section-bg-mobile.webp?v=3) 0 0 no-repeat;
          background-size: cover;
          aspect-ratio: 665/1990;

          .page-title {
            font-size: 80px;
          }

          .page-lead {
            font-size: 20px;
            font-weight: 700;
            max-width: 90%;

            :deep(sup) {
              margin-left: -4px;
            }
          }
        }

        &.carousel-container {
          background: transparent;
          border-radius: 0;
        }

        > * {
          font-family: 'Big Shoulders Display', sans-serif !important;
        }

        .page-title {
          color: var(--Colors-White, #fff);
          font-size: 50px;
          font-weight: 700;
          line-height: 100%;
          text-transform: uppercase;
          margin-bottom: 24px;
        }

        .page-subtitle {
          color: var(--Colors-White, #fff);
          font-size: 32px;
          font-weight: 700;
          line-height: 120%;
          text-transform: uppercase;
          margin-bottom: 16px;
        }

        .page-lead {
          color: var(--Colors-White, #fff);
          font-family: 'Barlow', sans-serif;
          font-size: 16px;
          font-weight: 400;
          line-height: 150%;
          margin-bottom: 24px;
        }

        .play-button {
          height: 48px;
          font-family: 'Inter', sans-serif !important;
          font-size: 16px;
          font-weight: 700;
          min-width: 252px;
          width: fit-content;
          text-transform: uppercase;
        }

        &.deposit-options {
          overflow: unset;
          margin-bottom: 128px;

          .page-title {
            font-size: 60px;
            text-align: center;
            padding-top: 20px;
          }

          .page-lead {
            text-align: center;
            font-weight: 400;
          }
        }

        &.top-section {
          justify-content: space-between;

          .top-block {
            align-items: center;
          }

          .page-title {
            font-size: 56px;
            text-align: center;
          }

          .page-subtitle {
            text-align: center;
          }

          .page-lead {
            text-align: center;
            font-weight: 700;

            span {
              font-size: 24px;
              font-weight: 800;
              font-style: italic;
            }
          }
        }

        &.first-section {
          background: url('/images/hp-lo/baner-background.webp?v=1') center center / cover no-repeat;
        }

        &.game-section {
          .pvp-bg {
            position: absolute;
            pointer-events: none;
          }

          .game-tabs {
            position: relative;
            z-index: 1;
          }

          .page-title {
            font-size: 80px;
            text-align: center;
            text-transform: none;
          }

          .page-lead {
            text-align: center;
            margin-bottom: 32px;
          }
        }

        &.top-section {
          .page-subtitle {
            text-transform: none;
          }
        }
      }

      .top-block {
        display: flex;
        flex-direction: column;
        padding: 40px 16px 0;
      }

      .art-devices {
        width: 100%;
        position: relative;
        top: 5px;
        max-width: 720px;
        margin-right: 50px;

        svg {
          max-width: 40px;
        }
      }

      .art-characters {
        position: absolute;
        bottom: 0;
        left: 0;
        background: url(/images/hp-lo/hero-section-characters-mobile.webp?v=3) 0 0 no-repeat;
        background-size: cover;
        width: 100%;
        aspect-ratio: 369/556;

        @media (min-width: 420px) {
          aspect-ratio: 1900/2200;
        }

        @media (min-width: 412px) {
          bottom: -6vw;
        }

        @media (min-width: 752px) {
          bottom: -20vw;
        }
      }

      .art-crypto {
        background: url(/images/hp-lo/art-coins-mobile.webp?v=1) 0 0 no-repeat;
        width: 100%;
        aspect-ratio: 950/253;
        background-size: cover;
        margin-bottom: 60px;
      }

      .kado-text-wrapper {
        display: flex;
        justify-content: flex-end;
        padding-right: 40px;
        margin-bottom: 50vw;
      }

      .kado-text {
        background: url(/images/hp-lo/kado-text.webp?v=2) 0 0 no-repeat;
        width: 100%;
        max-width: 53%;
        aspect-ratio: 600/265;
        background-size: cover;
      }

      .art-cards {
        position: absolute;
        width: 100%;
        bottom: 0;
        transform: translateY(44%);
        background: url(/images/hp-lo/art-cards-mobile.webp?v=1) 0 0 no-repeat;
        aspect-ratio: 824/918;
        background-size: cover;
      }

      .game-tabs {
        display: flex;
        gap: 10px;
        padding: 6px;
        border-radius: 20px;
        width: calc(100% - 20px);
        max-width: 600px;
        margin-inline: auto;
      }

      .game-tab {
        display: flex;
        padding: 20px 0;
        justify-content: center;
        align-items: center;
        gap: 4px;
        flex: 1 0 0;
        border-radius: 10px;
        background: rgba(255, 255, 255, 0.05);
        cursor: pointer;

        span,
        svg {
          opacity: 0.4;
        }

        &--active {
          background: #58198a;

          span,
          svg {
            opacity: 1;
          }
        }

        &:hover {
          filter: brightness(105%);
        }

        &:active {
          filter: brightness(97%);
        }

        svg {
          max-height: 20px;
        }

        span {
          color: var(--Colors-White, #fff);
          font-family: 'Barlow', sans-serif;
          font-size: 14px;
          font-weight: 700;
          line-height: 150%;
          letter-spacing: 0.42px;
        }
      }

      .game-list {
        position: relative;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
        gap: 16px;
        margin-top: 32px;
        margin-bottom: 60px;
        width: calc(100% - 40px);
        margin-inline: auto;

        @media screen and (min-width: 1600px) {
          grid-template-columns: repeat(3, 1fr);
        }

        &:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          height: 55%;
          background: linear-gradient(180deg, rgba(28, 6, 48, 0) 60%, #1c0630 90%);
          z-index: 1;
          pointer-events: none;
        }
      }

      .all-games-button {
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        margin-inline: auto;
        height: 48px;
        color: var(--Colors-Black, #000);
        text-align: center;
        font-family: 'Inter', sans-serif !important;
        font-size: 16px;
        font-weight: 700;
        line-height: 150%;
        text-transform: uppercase;
        z-index: 2;
        padding: 12px 32px;
        width: max-content;
      }

      .game-card {
        display: flex;
        align-items: center;
        border-radius: 10px;
        overflow: hidden;
        aspect-ratio: 380/254;
        width: 100%;
        max-width: 600px;

        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: top center;
        }
      }

      .svg-wrapper {
        --shadow-color: rgba(53, 15, 83, 0.2);
        width: 74px;
        height: 74px;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.7);
        display: flex;
        align-items: center;
        justify-content: center;
        filter: drop-shadow(0px 0px 7px #7026ab) drop-shadow(0px 0px 7px #7026ab);
        cursor: pointer;
        box-shadow: 0 0 0 0 var(--shadow-color);
        animation: play-pulse-anim 1s linear infinite;
        animation-delay: 0s;

        &:hover {
          background: #121111;
          --shadow-color: rgba(53, 15, 83, 0.4);
        }

        &:active {
          --shadow-color: rgba(53, 15, 83, 0.1);
        }

        &:before {
          --s: 2s;
        }

        &:after {
          --s: 3s;
        }

        &:before,
        &:after {
          content: '';
          width: 100%;
          height: 100%;
          border-radius: 50%;
          position: absolute;
          box-shadow: 0 0 0 0 var(--shadow-color);
          animation: play-pulse-anim 3s linear infinite;
          animation-delay: var(--s, 0s);
        }

        img {
          translate: 3px 0;
        }
      }
    }

    @container loggedOutView (min-width: 380px) {
      .hero-bg {
        max-height: 830px;
      }

      .top-block {
        padding: 40px 40px 0;
      }
    }

    @container loggedOutView (min-width: 470px) {
      .game-tab {
        svg {
          display: inline-block;
          flex-shrink: 0;
          max-height: 20px;
        }
      }
    }

    @container loggedOutView (min-width: 480px) {
      .hero-bg {
        max-height: 880px;
      }

      section.top-section .page-subtitle {
        font-size: 40px;
      }

      .deposit-options,
      .game-section {
        .page-title {
          font-size: 100px !important;
        }
      }
    }

    @container loggedOutView (min-width: 550px) {
      .hero-bg {
        max-height: 980px;
      }

      .game-list,
      .game-tabs {
        width: calc(100% - 80px);
      }

      .game-tab {
        gap: 10px;
      }
    }

    @container loggedOutView (min-width: 936px) {
      .svg-wrapper {
        left: 23cqi;
        top: auto;
        right: auto;
        bottom: 8cqi;
        transform: translateX(0);
      }
    }

    @container loggedOutView (min-width: 1034px) {
      .svg-wrapper {
        left: 28cqi;
        top: auto;
        right: auto;
        bottom: 11cqi;
        transform: translateX(0);
      }
    }

    @container loggedOutView (min-width: 1152px) {
      .svg-wrapper {
        left: 29cqi;
        top: auto;
        right: auto;
        bottom: 12cqi;
        transform: translateX(0);
      }
    }

    @container loggedOutView (min-width: 1172px) {
      .svg-wrapper {
        left: 48%;
        top: auto;
        right: auto;
        bottom: 40%;
        transform: translateX(0);
      }
    }

    @container loggedOutView (min-width: 704px) {
      .svg-wrapper {
        width: 74px;
        height: 74px;
        border-radius: 50%;
        background: rgba(0, 0, 0, 0.5);

        display: flex;
        align-items: center;
        justify-content: center;
        filter: drop-shadow(0px 0px 7px #7026ab) drop-shadow(0px 0px 7px #7026ab);

        cursor: pointer;
      }

      svg {
        max-width: 40px;
      }

      section {
        display: flex;
        align-items: center;

        &.hero-bg,
        &.deposit-options,
        &.game-section {
          display: block;
        }

        &.top-section {
          .top-block {
            align-items: flex-start;
            padding: 40px 0 40px 40px;
          }

          .page-title,
          .page-subtitle,
          .page-lead {
            text-align: left;
          }

          .art-devices {
            max-height: 90%;
            right: auto;
            // left: 40vw;
          }
        }
      }

      .top-block {
        flex-basis: 58%;
        flex-shrink: 0;
        max-width: 520px;
      }

      .deposit-options {
        .top-block {
          max-width: none;
        }

        .art-crypto {
          background: url(/images/hp-lo/art-coins-desktop.webp?v=1) 0 0 no-repeat;
          aspect-ratio: 2607/486;
          background-size: cover;
          margin-inline: auto;
          max-width: calc(100% - 140px);
        }

        .bottom-block {
          display: flex;
          flex-direction: row-reverse;
          width: 75%;
          margin-inline: auto;
          margin-bottom: -10vw;

          div {
            flex-basis: 100%;
          }
        }

        .kado-text-wrapper {
          margin-bottom: 0;
          padding-right: 0;
          align-items: center;
          justify-content: center;
          transform: translateY(-4vw);
        }

        .kado-text {
          background: url(/images/hp-lo/kado-text.webp?v=3) 0 0 no-repeat;
          aspect-ratio: 740/326;
          background-size: cover;
        }

        .art-cards {
          position: relative;
          transform: translateY(0);
          background: url(/images/hp-lo/art-cards-desktop.webp?v=1) 0 0 no-repeat;
          aspect-ratio: 1168/1301;
          background-size: cover;
        }
      }

      .game-section {
        .top-block {
          max-width: none;
          padding-top: 120px;
        }
      }

      .art-devices {
        img {
          object-fit: contain;
          width: 100%;
          height: 100%;
        }
      }
    }

    @container loggedOutView (min-width: 776px) {
      section.hero-bg {
        .top-block {
          max-width: none;
        }
      }

      .art-characters {
        position: absolute;
        bottom: 0;
        left: 0;
        background: url(/images/hp-lo/hero-section-characters-desktop.webp?v=3) 0 0 no-repeat;
        background-size: cover;
        width: 100%;
        aspect-ratio: 1881/1480;
        filter: blur(0);

        &::after {
          content: '';
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 95%;
          background: linear-gradient(to right, transparent, rgba(35, 12, 64, 0.9));
          filter: blur(10px);
          pointer-events: none;
        }
      }
    }

    @container loggedOutView (min-width: 928px) {
      section.hero-bg {
        display: flex;
        flex-direction: row-reverse;
        align-items: center;
        background: url(/images/hp-lo/hero-section-bg-desktop.webp?v=3) 0 0 no-repeat;
        background-size: cover;
        aspect-ratio: 2896/1334;
        max-height: none;

        &::before {
          content: '';
          position: absolute;
          z-index: 1;
          top: 0;
          bottom: 0;
          left: 0;
          width: 15%;
          border-radius: 20px;
          background: linear-gradient(90deg, #1c0630 5.5%, rgba(30, 7, 51, 0) 84.5%);
          pointer-events: none;
        }

        .top-block {
          flex-basis: 50%;
        }
      }

      .art-characters {
        width: 50%;
      }

      section.top-section {
        .page-title {
          font-size: 80px;
        }

        .page-subtitle {
          font-size: 49px;
        }

        .page-lead {
          font-size: 23px;
        }
      }
    }

    @container loggedOutView (min-width: 1034px) {
      section.top-section .top-block {
        padding: 40px 0 0 80px;
      }
    }

    @container loggedOutView (min-width: 1104px) {
      section.hero-bg {
        .top-block {
          flex-basis: 40%;
        }

        .page-title {
          font-size: 70px !important;
        }

        .art-characters {
          width: 60%;
        }
      }

      section.deposit-options {
        .top-block {
          flex-basis: 100%;
          align-items: center;
          width: 100%;
          max-width: none;
        }

        .page-title {
          font-size: 100px !important;
        }

        .page-lead {
          max-width: 715px;
        }
      }
    }

    @container loggedOutView (min-width: 1152px) {
      section.hero-bg {
        .page-title {
          font-size: 100px !important;
        }
      }

      section.top-section .top-block {
        padding: 40px 0 40px 120px;
        flex-basis: 50%;
        max-width: max-content;
      }
    }

    @container loggedOutView (min-width: 1232px) {
      section.top-section .top-block {
        padding: 60px 0 60px 178px;
        flex-basis: 50%;
        max-width: max-content;
      }
    }

    @container bannerImage (max-width: 380px) {
      &::v-deep {
        .banner-title {
          font-size: 56px;
          margin-bottom: 12px;
        }

        .banner-lead {
          font-size: 16px;
        }
      }
    }

    @container bannerImage (min-width: 380px) {
      &::v-deep {
        .v-responsive__content {
          padding: 40px !important;
        }

        .banner-title {
          font-size: 60px;
          margin-bottom: 24px;
        }

        .banner-lead {
          font-size: 16px;
        }
      }
    }

    @container bannerImage (min-width: 410px) {
      &::v-deep {
        .v-responsive__content {
          align-self: center !important;
        }

        .banner-title {
          font-size: 32px;
          margin-bottom: 12px;
          max-width: 50%;
        }

        .banner-lead {
          font-size: 11px;
          max-width: 50%;
        }
      }
    }

    @container bannerImage (min-width: 480px) {
      &::v-deep {
        .banner-title {
          font-size: min(7.7cqi, 90px);
          max-width: 50%;
          margin-bottom: 24px;
        }

        .banner-lead {
          font-size: min(2.5cqi, 16px);
          max-width: min(45%, 400px);
        }
      }
    }

    @container bannerImage (min-width: 580px) {
      &::v-deep .v-responsive__content {
        padding: 60px !important;
      }
    }
  }
</style>
